import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import style from './MfLinearIndeterminateProgress.module.scss';

const MfLinearIndeterminateProgress = () => (
  <LinearProgress className={style.linearProgress} />
);

export default MfLinearIndeterminateProgress;
